import React from 'react'
import { SvgIconProps } from '../Icon.types'

export const FooterLinkedIn: React.FC<SvgIconProps> = ({
  width = 28,
  height = 29,
  fill = 'currentColor',
  title = '',
  className,
  ...props
}) => (
  <svg
    viewBox='0 0 28 29'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
    aria-hidden={!title}
    focusable='false'
    width={width}
    height={height}
    {...props}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M0 0.125V28.125H28V0.125H0ZM8.82219 22.875H4.75453V10.6414H8.82219V22.875ZM6.78891 8.96906H6.76266C5.39656 8.96906 4.515 8.02953 4.515 6.85594C4.515 5.65719 5.425 4.74172 6.81625 4.74172C8.20969 4.74391 9.06281 5.65828 9.09016 6.85594C9.09016 8.02953 8.20641 8.96906 6.78891 8.96906ZM23.485 22.875H19.4195V16.3289C19.4195 14.685 18.8289 13.5628 17.36 13.5628C16.2356 13.5628 15.5662 14.3186 15.2731 15.0492C15.1648 15.3106 15.1386 15.6759 15.1386 16.0423V22.875H11.072C11.072 22.875 11.1267 11.7887 11.072 10.6414H15.1386V12.3728C15.6789 11.5394 16.6458 10.3527 18.8037 10.3527C21.4791 10.3527 23.485 12.1016 23.485 15.8597V22.875Z'
      fill={fill}
    />
  </svg>
)

export default FooterLinkedIn
